export default "__VITE_ASSET__ozlF2kzp__"